import React from "react"
import {observer} from "mobx-react"
import {injectIntl} from "react-intl"

import {Grid, Container} from "@material-ui/core"

import RouterStore from "../../store/RouterStore"
import settings from "../../config/settings"

function XsPublicHeader() {
	return (
		<div className="main_header">
			<Container style={{maxWidth: "90%"}}>
				<Grid container alignItems="center" className="pt-2 pb-2" spacing={3}>
					<Grid item>
						<img
							src="/public/images/logo_zelena.svg"
							className="pointer"
							onClick={() => {
								RouterStore.push("/")
							}}
						/>
					</Grid>
					{settings.SERVERROLE !== "PROD" && (
						<Grid className="bold redDanger ml-2" style={{fontSize: "32px"}}>
							{settings.SERVERROLE}
						</Grid>
					)}
					<Grid item container xs spacing={10} justify="flex-end">
						<Grid item>
							<img style={{height: "50px"}} src="/public/images/footerLogo2.svg" />
						</Grid>
						<Grid item>
							<img style={{height: "50px"}} src="/public/images/footerLogo1.svg" />
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</div>
	)
}

export default injectIntl(observer(XsPublicHeader))

